/**
 * Returns the day-of-year (1-indexed) for a given date.
 * @param {Date} date
 * @returns {number}
 */
export function getDayOfYear(date) {
  const start = new Date(date.getFullYear(), 0, 0)
  const oneDay = 1000 * 60 * 60 * 24
  return Math.floor((date - start) / oneDay)
}

/**
 * Returns the featured charity for the given date.
 * Rotates deterministically through the active charity list using dayOfYear % count.
 *
 * @param {Array} charities - full charities array from Redux state
 * @param {Date} date
 * @returns {Object|null}
 */
export function getDailyCharity(charities, date) {
  const active = charities.filter((c) => c.active)
  if (active.length === 0) return null
  return active[getDayOfYear(date) % active.length]
}
